package com.essntl.features.message.ui.all_conversation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.domain.useCase.SortConversations
import com.essntl.uikit.rememberFind

@Composable
fun AllConversationState.rememberFilteredConversations(): List<WhapiChatModel> {
    return remember(getAllWhapiChats, getAllWhapiGroups, filterOptions) {
        SortConversations(
            conversations = allConversations,
            filterOptions = filterOptions,
        )
    }
}

@Composable
fun AllConversationState.rememberClient(phoneNumber: String?) =
    rememberFind(
        getAllClient.data.orEmpty(),
        phoneNumber
    ) { client -> client.telephone }